import { motion, useReducedMotion } from 'motion/react'

const chapters = [
  {
    title: 'Falling for AI',
    period: 'University years',
    text: 'I fell for artificial intelligence through clustering algorithms, then graduated with honors in Computer Science specializing in AI.',
  },
  {
    title: 'Learning the craft',
    period: 'Sicily · 2011',
    text: 'I began my career as a software engineer in Sicily. I learned to treat every system as a craft: useful, resilient and expressive.',
  },
  {
    title: 'Building virtual worlds',
    period: 'Vrtuale · Built in Italy',
    text: 'With Vrtuale.com, I created virtual worlds for B2B and events. I raised capital, grew a team and scaled the company across Italy.',
  },
  {
    title: 'Crossing the ocean',
    period: 'San Francisco · 2025',
    text: 'I moved to San Francisco to focus completely on my next ambition, establishing my base at 201 Spear Street.',
  },
  {
    title: 'Finding my niche',
    period: 'Coderblock.ai · Now',
    text: 'With vibe coding, I found my niche: I am building Coderblock.ai so anyone can describe an idea and work with a team of AI employees to design, code and ship it.',
  },
]

export default function FounderJourney() {
  const reduceMotion = useReducedMotion()

  return (
    <section id="journey" aria-labelledby="journey-heading" className="pb-16 text-foreground sm:pb-24">
      <div className="creator-container">
        <div className="rounded-3xl border border-border bg-muted p-6 sm:p-9">
          <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
            <div>
              <p className="creator-label text-muted-foreground">The journey</p>
              <h2 id="journey-heading" className="creator-display mt-3 text-3xl sm:text-4xl">Five chapters, one through line.</h2>
            </div>
            <p className="max-w-sm text-base leading-7 text-muted-foreground">I use technology to turn imagination into something real.</p>
          </div>
          <ol className="mt-8 grid list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2 xl:grid-cols-5">
            {chapters.map((chapter, index) => (
              <motion.li key={chapter.title} initial={reduceMotion ? false : { opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: reduceMotion ? 0 : 0.4, delay: reduceMotion ? 0 : index * 0.04 }} className={`bento-card min-w-0 p-5 ${index === chapters.length - 1 ? 'bg-primary text-primary-foreground sm:col-span-2 xl:col-span-1' : 'bg-card'}`}>
                <span aria-hidden="true" className={`inline-flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold ${index === chapters.length - 1 ? 'bg-primary-foreground text-primary' : 'bg-accent text-foreground'}`}>{String(index + 1).padStart(2, '0')}</span>
                <p className="mt-5 text-xs font-semibold uppercase tracking-wide">{chapter.period}</p>
                <h3 className="mt-2 font-display text-xl font-bold tracking-tight">{chapter.title}</h3>
                <p className="mt-3 text-sm leading-7">{chapter.text}</p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
